import { useEffect, useState } from "react";
import { toast } from '@CommonComponents/toast';
import { client } from "@Utils";

export function useFetchData(coursenum) {
  const [activities, setActivities] = useState({});
  const [students, setStudents] = useState({});
  const [state, setState] = useState("loading");

  useEffect(() => {
    async function fetchData() {
      try {
        const resp = await client.get(
          `/instructor/due_dates.fetch/${coursenum}`,
        );
        setState("loaded");
        setStudents(resp.data.students);
        setActivities(parseActivities(resp.data.activities));
      } catch (err) {
        setState("error");
        toast.error(err.response.data.error)
        throw err;
      }
    }
    fetchData();
  }, []);

  function refresh(data) {
    setStudents(data.students);
    setActivities(parseActivities(data.activities));
  }

  return {
    state,
    activities,
    students,
    refresh,
  };
}

function parseActivities(activities) {
  return Object.fromEntries(
    Object.entries(activities).map(([key, act]) => {
      const date = new Date(act.current_due_date);
      return [
        key,
        {
          ...act,
          current_due_date: isNaN(date.getTime()) ? undefined : date,
        },
      ];
    }),
  );
}
